<ng-container *ngIf="isMultiFamily; else singleFamily">
  <ng-container *ngIf="featureService.selectIsHolidayProgramOrHolidayAtHomeActive() | async">
    <vi-icon name="{{ 'holiday-program-white' }}" [size]="20"></vi-icon>
  </ng-container>
</ng-container>
<ng-template #singleFamily>
  <ng-container
    *ngIf="
      (holiday$ | async | ready)?.properties?.active?.value === true ||
      (holidayAtHome$ | async | ready)?.properties?.active?.value === true
    "
  >
    <vi-icon name="{{ 'holiday-program-white' }}" [size]="20"></vi-icon>
  </ng-container>
</ng-template>
